import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../css/WriteReview.css';

const WriteReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [name, setName] = useState('');  // New state for the name
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [message, setMessage] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(true); // Initially assuming user is logged in

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsLoggedIn(false);
    } else {
      setName(localStorage.getItem('userName') || ''); // Optionally pre-fill name if available
    }
  }, []);

  // Handle the review submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isLoggedIn) {
      setMessage('Please log in to write a review');
      return;
    }

    const productId = id;
    
    const reviewData = {
      name,          // Send the name value
      no: rating,
      productId,
      comment
    };

    const token = localStorage.getItem('token'); // Retrieve JWT token from localStorage

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/user/addReviewRating`, reviewData, {
        headers: {
          Authorization: `Bearer ${token}` // Pass token in the Authorization header
        }
      });

      if (response.status === 200) {
        setMessage('Review submitted successfully!');
        // Optionally, redirect to the product details page or clear the form
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      setMessage('Failed to submit review. Please try again later.');
    }
  };

  return (
    <div className="write-review-container">
      <h1>Write a Review</h1>
      
      {!isLoggedIn && <p className="error-message">{message}</p>}
      
      {isLoggedIn && (
        <form onSubmit={handleSubmit}>
          {/* Name Field */}
          <div className="name-field">
            <label htmlFor="name">Your Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* Rating Field */}
          <div className="rating-selection">
            <label htmlFor="rating">Rating:</label>
            <input
              type="number"
              id="rating"
              name="rating"
              value={rating}
              onChange={(e) => setRating(e.target.value)}
              min="1"
              max="5"
              required
            />
          </div>

          {/* Comment Field */}
          <div className="comment-field">
            <label htmlFor="comment">Comment:</label>
            <textarea
              id="comment"
              name="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows="4"
              required
            />
          </div>

          <button type="submit" className="submit-review-button">Submit Review</button>
        </form>
      )}

      {message && <p className="error-message">{message}</p>}
    </div>
  );
};

export default WriteReview;
